import { useToast } from "@codat/orchard-ui";
import { useCreateConnectionQuery } from "api/company";
import { useDemoMode } from "contexts/DemoModeContext";
import { SourceType } from "model";
import { useState } from "react";
import { getDemoModePlatform, getTryCatchErrorMessage } from "utils";

import useFilteredQueryString from "./useFilteredQueryString";

interface UseCreateConnectionClickHandlerArgs {
  companyId: string;
  platformKey: string | undefined;
  sourceType: SourceType | undefined;
}

export const useCreateConnectionClickHandler = (
  args: UseCreateConnectionClickHandlerArgs
): [boolean, () => Promise<void>] => {
  const search = useFilteredQueryString();
  const [isLoading, setIsLoading] = useState(false);

  const { addToast } = useToast();
  const { isDemo } = useDemoMode();

  const companyId = args.companyId;
  const platformKey =
    isDemo &&
    args.sourceType &&
    args.sourceType !== "Banking" &&
    args.sourceType !== "Other"
      ? getDemoModePlatform(args.sourceType)
      : args.platformKey;

  const [, executePost] = useCreateConnectionQuery({
    companyId,
    platformKey: platformKey ?? "",
    query: search,
  });

  return [
    isLoading,
    async () => {
      try {
        setIsLoading(true);
        const createConnectionResponse = await executePost();
        window.location.assign(createConnectionResponse.data.linkUrl);
      } catch (e) {
        setIsLoading(false);
        addToast({
          message: `${getTryCatchErrorMessage(e)}: Failed to create connection`,
          variant: "error",
        });
      }
    },
  ];
};
